(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire7c47"];
parcelRequire.register("jAbbt", function(module, exports) {

var $0aqV5 = parcelRequire("0aqV5");
const $e41a0e09c6979934$var$filterItems = document.querySelectorAll(".i-filter");
$e41a0e09c6979934$var$filterItems.forEach((filter)=>{
    const inputs = filter.querySelectorAll("input");
    const clear = filter.querySelector(".i-filter__clear");
    inputs.forEach((input)=>{
        input.addEventListener("change", ()=>filter.dispatchEvent(new Event("filter")));
    });
    clear?.addEventListener("click", (e)=>{
        e.preventDefault();
        inputs.forEach((input)=>{
            if (input.type == "checkbox") input.checked = false;
            else if (input.classList.contains("flatpickr")) (0, $0aqV5.dateClear)(input);
            else input.value = "";
        });
        filter.dispatchEvent(new Event("filter"));
    });
});

});

})();
//# sourceMappingURL=filter-item.4f4db6a3.js.map
